<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">{{ title }}</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Empresa Relacionada</label>
                      <input
                        v-model="empresaBusca"
                        @input="buscarEmpresas"
                        type="text"
                        placeholder="Digite o nome para buscar..."
                        class="mt-2 block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                      <ul
                        v-if="sugestoesEmpresas.length"
                        class="mt-1 border border-gray-300 rounded-md bg-white shadow-lg p-2 max-h-40 overflow-y-auto"
                      >
                        <li
                          v-for="(empresa, index) in sugestoesEmpresas"
                          :key="index"
                          @click="vincularEmpresaLista(empresa)"
                          class="cursor-pointer hover:bg-gray-100 p-2 rounded text-sm text-gray-700"
                        >
                          {{ empresa.nome }}
                        </li>
                      </ul>
                      <div v-if="data.empresa_nome" class="mt-2 text-sm font-semibold text-green-700">
                        Selecionada: {{ data.empresa_nome }}
                      </div>
                      <!-- Empresas que utilizam os planos (Apenas na edição) -->
                      <div v-if="data.id && data.filiais && data.filiais.length" class="mt-3 p-3 bg-gray-50 border border-gray-200 rounded-md">
                        <h4 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Empresas que utilizam os planos</h4>
                        <ul class="mt-1 space-y-1">
                          <li v-for="filial in data.filiais" :key="filial.id" class="text-sm text-gray-700 flex items-center gap-1.5">
                            <span class="inline-block w-1.5 h-1.5 rounded-full bg-indigo-500"></span>
                            {{ filial.nome }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Seguradora Relacionada</label>
                      <input
                        v-model="seguradoraBusca"
                        @input="buscarSeguradoras"
                        type="text"
                        placeholder="Digite o nome para buscar..."
                        class="mt-2 block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                      <ul
                        v-if="sugestoesSeguradoras.length"
                        class="mt-1 border border-gray-300 rounded-md bg-white shadow-lg p-2 max-h-40 overflow-y-auto"
                      >
                        <li
                          v-for="(seguradora, index) in sugestoesSeguradoras"
                          :key="index"
                          @click="vincularSeguradoraLista(seguradora)"
                          class="cursor-pointer hover:bg-gray-100 p-2 rounded text-sm text-gray-700"
                        >
                          {{ seguradora.nome }}
                        </li>
                      </ul>
                      <div v-if="data.seguradora_nome" class="mt-2 text-sm font-semibold text-blue-700">
                        Selecionada: {{ data.seguradora_nome }}
                      </div>
                  </div>
                  <div
                    v-for="(input, index) in inputsList"
                    :key="index"
                    class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2"
                  >
                    <label
                      :for="input.name"
                      class="block text-sm font-medium leading-6 text-gray-900"
                    >
                      {{ input.label }}
                    </label>

                    <!-- Select -->
                    <select
                      v-if="input.type === 'select'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option value="">Selecione uma opção</option>
                      <option
                        v-for="(opt, i) in input.options"
                        :key="i"
                        :value="opt"
                      >
                        {{ opt }}
                      </option>
                    </select>

                    <!-- Textarea -->
                    <textarea
                      v-else-if="input.type === 'textarea'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      rows="3"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    ></textarea>

                    <!-- Input normal -->
                    <input
                      v-else
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :type="input.type"
                      :readonly="input.readonly || false"
                      :required="true"
                      :minlength="input.name === 'nome' ? 4 : null"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                   <!-- Campos dinâmicos gerados por extraInputs -->
                    <div v-if="extraInputs" class="flex gap-4 flex-wrap">
                      <!-- Iterar sobre cada extraInput para gerar o campo -->
                      <div v-for="(input, index) in extraInputs" :key="index" class="flex-1 min-w-[200px]">
                        <label :for="input.name" class="block text-sm font-medium leading-6 text-gray-900">{{ input.label }}</label> 
                        <input
                          v-model="extraObect[input.name]"
                          :id="input.name"
                          :name="input.name"
                          :type="input.type"
                          :required="false"
                          class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>        

                  <!-- Botão de adicionar novo conjunto de campos dinâmicos -->
                  <div v-if="extraInputs" class="w-full">
                    <button @click.prevent="addExtraField" type="button" class="mt-2 w-full flex justify-center rounded-md bg-green-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-400">Adicionar {{ extraInputName }}</button>
                  </div>
                  <!-- Container lado a lado para Decessos e Coberturas -->
                  <div class="w-full flex flex-col lg:flex-row gap-4 mt-6">
                    
                    <!-- Lado Esquerdo: Decessos -->
                    <div class="flex-1 flex flex-col border border-indigo-200 p-4 rounded-md shadow-sm">
                      <div class="relative mb-4">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-center">
                          <span class="bg-white text-center px-2 text-sm text-gray-500 z-10">
                          <strong> Decessos (Auxílio Funeral) </strong>
                          </span>
                        </div>
                      </div>

                      <div class="w-full flex items-center gap-4 p-3 mb-4 border border-indigo-100 rounded-md bg-indigo-50/30">
                        <div class="flex items-center gap-2">
                            <input
                                v-model="data.reajusta_decesso"
                                type="checkbox"
                                id="reajusta_decesso"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <label for="reajusta_decesso" class="text-sm font-medium text-gray-900">Incidir Reenquadramento/IPCA?</label>
                        </div>
                      </div>

                      <div class="grid grid-cols-1 gap-4 flex-1">
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Nome do Decesso</label>
                          <input v-model="novoDecesso.nome" class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"/>
                        </div>
                        <div class="grid grid-cols-2 gap-4">
                          <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Sigla</label>
                            <input v-model="novoDecesso.sigla" class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"/>
                          </div>
                          <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Capital</label>
                            <input v-model="novoDecesso.valor_capital" type="number" step="0.01" class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"/>
                          </div>
                        </div>
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Prêmio</label>
                          <input v-model="novoDecesso.valor_premio" type="number" step="0.01" class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"/>
                        </div>
                        <div class="flex justify-end">
                          <button @click.prevent="adicionarDecesso" class="text-sm px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">
                            Adicionar Decesso
                          </button>
                        </div>
                        
                        <!-- Lista de Decessos -->
                        <div class="border-t pt-4 mt-auto">
                          <h3 class="text-sm font-semibold text-gray-800 mb-2">Decessos do Plano</h3>
                          <ul class="space-y-2">
                            <li v-for="(decesso, index) in data.decessos" :key="index" class="flex justify-between items-center bg-gray-100 px-3 py-2 rounded-md">
                              <div class="text-sm text-gray-700 w-full" :class="{ 'opacity-50 line-through': decesso.marcado_remocao }">
                                <p><strong>Nome:</strong> {{ decesso.nome }} ({{ decesso.sigla }})</p>
                                <p><strong>Capital:</strong> R$ {{ decesso.valor_capital || '0' }} | <strong>Prêmio:</strong> R$ {{ decesso.valor_premio || '0' }}</p>
                              </div>
                              <div class="flex flex-col gap-2 shrink-0">
                                <span v-if="decesso.marcado_remocao" class="text-xs text-red-500 font-bold bg-red-100 px-2 py-1 rounded">Excluir</span>
                                <button v-if="!decesso.marcado_remocao" @click.prevent="removerDecesso(index)" class="text-red-600 text-xs underline hover:text-red-800">Remover</button>
                                <button v-else @click.prevent="desfazerRemocaoDecesso(index)" class="text-green-600 text-xs underline hover:text-green-800">Desfazer</button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <!-- Lado Direito: Coberturas -->
                    <div class="flex-1 flex flex-col border border-indigo-200 p-4 rounded-md shadow-sm">
                      <div class="relative mb-4">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-center">
                          <span class="bg-white text-center px-2 text-sm text-gray-500 z-10">
                          <strong> Coberturas </strong>
                          </span>
                        </div>
                      </div>

                      <div class="grid grid-cols-1 gap-4 flex-1">
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Nome da Cobertura</label>
                          <input v-model="novaCobertura.nome" class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"/>
                        </div>
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Chave Placeholder</label>
                          <input v-model="novaCobertura.chave_placeholder" class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"/>
                        </div>
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Valor (Opcional)</label>
                          <input v-model="novaCobertura.valor" class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"/>
                        </div>
                        <div class="flex justify-end mt-4">
                          <button @click.prevent="adicionarCobertura" class="text-sm px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">
                            Adicionar Cobertura
                          </button>
                        </div>
                        
                        <!-- Lista de Coberturas -->
                        <div class="border-t pt-4 mt-auto">
                          <h3 class="text-sm font-semibold text-gray-800 mb-2">Coberturas do Plano</h3>
                          <ul class="space-y-2">
                            <li v-for="(cobertura, index) in data.coberturas" :key="index" class="flex justify-between items-center bg-gray-100 px-3 py-2 rounded-md">
                              <div class="text-sm text-gray-700 w-full" :class="{ 'opacity-50 line-through': cobertura.marcado_remocao }">
                                <p><strong>Nome:</strong> {{ cobertura.nome }}</p>
                                <p><strong>Chave:</strong> {{ cobertura.chave_placeholder }}</p>
                                <p><strong>Valor:</strong> {{ cobertura.valor }}</p>
                              </div>
                              <div class="flex flex-col gap-2 shrink-0">
                                <span v-if="cobertura.marcado_remocao" class="text-xs text-red-500 font-bold bg-red-100 px-2 py-1 rounded">Excluir</span>
                                <button v-if="!cobertura.marcado_remocao" @click.prevent="removerCobertura(index)" class="text-red-600 text-xs underline hover:text-red-800">Remover</button>
                                <button v-else @click.prevent="desfazerRemocaoCobertura(index)" class="text-green-600 text-xs underline hover:text-green-800">Desfazer</button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- Regras -->
                  <div class="w-full col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-center">
                        <span class="bg-white text-center px-2 text-sm text-gray-500 z-10">
                        <strong> Regras </strong>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Formulário de Novas Regras -->
                  <div class="grid grid-cols-2 gap-4 border border-blue-200 p-4 rounded-md shadow-sm mt-6 col-span-2">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Nova Regra Reenquadramento</label>
                      <input
                        v-model="novaRegra.nome"
                        class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Observação</label>
                      <input
                        type="textarea"
                        v-model="novaRegra.observacao"
                        class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Idade Minima</label>
                      <input
                        v-model="novaRegra.idade_min"
                        type="number"
                        class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Idade Maxima</label>
                      <input
                        v-model="novaRegra.idade_max"
                        type="number"
                        class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">
                        Tipo de Regra
                      </label>

                      <select
                        v-model="novaRegra.tipo_reenquadramento"
                        class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                      >
                        <option value="" disabled>Selecione o tipo de Regra</option>

                        <option value="aniversario_segurado">Aniversário Segurado</option>
                        <option value="aniversario_apolice">Aniversário da Apólice (Plano)</option>
                        <option value="aniversario_apolice_cliente">Aniversário Apólice / Cliente</option>
                      </select>
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">
                        Coeficiente de Calculo
                      </label>

                      <select
                        v-model="novaRegra.tipo"
                        class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                      >
                        <option value="" disabled>Selecione o tipo de Coeficiente</option>

                        <option value="percentual">Percentual</option>
                        <option value="fixo">Fixo</option>
                      </select>
                    </div>
                    <div class="col-span-2 flex justify-end">
                      <button
                        @click.prevent="adicionarRegra"
                        class="text-sm px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                      >
                        Adicionar Regra
                      </button>
                    </div>
                    <div class="col-span-2 border-t pt-4">
                      <h3 class="text-sm font-semibold text-gray-800 mb-2">Regras do Plano</h3>
                      <ul class="space-y-2">
                        <li
                          v-for="(regra, index) in data.regras"
                          :key="index"
                          class="flex justify-between items-center bg-gray-100 px-3 py-2 rounded-md"
                        >
                          <div class="text-sm text-gray-700 w-full" :class="{ 'opacity-50 line-through': regra.marcado_remocao }">
                            <p><strong>Nome:</strong> {{ regra.nome }}</p>
                            <p><strong>Observação:</strong> {{ regra.observacao }}</p>
                            <p><strong>Idade Mínima:</strong> {{ regra.idade_min }}</p>
                            <p><strong>Idade Máxima:</strong> {{ regra.idade_max }}</p>
                            <p><strong>Coeficiente:</strong> {{ regra.tipo }}</p>
                            <p><strong>Tipo Reenq.:</strong> {{ regra.tipo_reenquadramento }}</p>
                          </div>

                          <div class="flex flex-col gap-2 shrink-0">
                            <span v-if="regra.marcado_remocao" class="text-xs text-red-500 font-bold bg-red-100 px-2 py-1 rounded">
                              Na fila para exclusão
                            </span>
                            <button
                              v-if="!regra.marcado_remocao"
                              @click.prevent="removerRegra(index)"
                              class="text-red-600 text-xs underline hover:text-red-800"
                            >
                              Remover
                            </button>
                            <button
                              v-else
                              @click.prevent="desfazerRemocaoRegra(index)"
                              class="text-green-600 text-xs underline hover:text-green-800"
                            >
                              Desfazer Exclusão
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <!-- Formulário de Novas Regras Ipca -->
                      <div class="grid grid-cols-2 gap-4 border border-blue-200 p-4 rounded-md shadow-sm mt-6 col-span-2">
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Nova Regra Ipca</label>
                          <input
                            v-model="novaRegraIpca.nome"
                            class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                          />
                        </div>

                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Observação</label>
                          <input
                            v-model="novaRegraIpca.observacao"
                            class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                          />
                        </div>
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">
                            Tipo de Regra (*acima de 12 meses após inclusão)
                          </label>

                          <select
                            v-model="novaRegraIpca.tipo_reenquadramento"
                            class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                          >
                            <option value="" disabled>Selecione o tipo de Regra</option>
                            <option value="aniversario_segurado">Aniversário Segurado</option>
                            <option value="aniversario_apolice">Aniversário da Apólice (Plano)</option>
                            <option value="aniversario_apolice_cliente">Aniversário Apólice / Cliente</option>
                            <option value="data_fixa">Mes Fixo</option>
                          </select>
                        </div>

                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">
                            Coeficiente de Calculo
                          </label>

                          <select
                            v-model="novaRegraIpca.tipo"
                            class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                          >
                            <option value="" disabled>Selecione o tipo de Coeficiente</option>
                            <option value="percentual">Percentual</option>
                            <option value="fixo">Fixo</option>
                            <option value="tabela">Tabela</option>
                          </select>
                        </div>
                        <div>
                          <label class="block text-sm font-medium text-gray-700 mb-1">Mês Para Cáculo caso seja mes fixo</label>
                          <input
                            v-model="novaRegraIpca.data_fixa"
                            type="month"
                            class="block w-full border border-gray-300 py-2 px-2 text-sm text-gray-900 rounded-md"
                          />
                        </div>

                        <div class="col-span-2 flex justify-end">
                          <button
                            @click.prevent="adicionarRegraIpca"
                            class="text-sm px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                          >
                            Adicionar Regra
                          </button>
                        </div>

                        <div class="col-span-2 border-t pt-4">
                          <h3 class="text-sm font-semibold text-gray-800 mb-2">Regras de Ipca</h3>
                          <ul class="space-y-2">
                            <li
                              v-for="(regra, index) in data.regrasIpca"
                              :key="index"
                              class="flex justify-between items-center bg-gray-100 px-3 py-2 rounded-md"
                            >
                              <div class="text-sm text-gray-700 w-full" :class="{ 'opacity-50 line-through': regra.marcado_remocao }">
                                <p><strong>Nome:</strong> {{ regra.nome }}</p>
                                <p><strong>Observação:</strong> {{ regra.observacao }}</p>
                                <p><strong>Coeficiente:</strong> {{ regra.tipo }}</p>
                                <p><strong>Tipo Reenq.:</strong> {{ regra.tipo_reenquadramento }}</p>
                              </div>

                              <div class="flex flex-col gap-2 shrink-0">
                                <span v-if="regra.marcado_remocao" class="text-xs text-red-500 font-bold bg-red-100 px-2 py-1 rounded">
                                  Na fila para exclusão
                                </span>
                                <button
                                  v-if="!regra.marcado_remocao"
                                  @click.prevent="removerRegraIpca(index)"
                                  class="text-red-600 text-xs underline hover:text-red-800"
                                >
                                  Remover
                                </button>
                                <button
                                  v-else
                                  @click.prevent="desfazerRemocaoRegraIpca(index)"
                                  class="text-green-600 text-xs underline hover:text-green-800"
                                >
                                  Desfazer Exclusão
                                </button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                  </div>
                  <!-- Botão de enviar formulário -->
                   <div v-if="Object.keys(data.extraFields).length">
                    <DynamicTable
                      :extraFields=" this.data.extraFields"
                      @remove-item="removeExtraField"
                    />
                   </div>
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">Cadastrar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import DynamicTable from '@/components/generalcomponents/DynamicTable.vue';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import SeguradoraRepository from '@/services/SeguradoraRepository.vue';
import debounce from 'lodash/debounce';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';

  export default {
    name: 'CommonForm',
    created(){
        this.buscarEmpresas = debounce((...args) => {
          this._buscarEmpresas(...args);
        }, 400);
        this.buscarSeguradoras = debounce((...args) => {
          this._buscarSeguradoras(...args);
        }, 400);
    },
    props: {
      inputsList: {
        type: Array,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      extraInputs:
      {
        type: Array,
        required: false
      },
      resetFormData:{
        type: Boolean,
        required:true
      },
      extraInputName: {
        type: String,
        required: false
      },
      placeHolderValues: {
        type: Object,
        required: false
      }
    },  
    watch: {
      resetFormData(newValue) { 
        if(newValue == true){
          this.data = {
            regras: [],
            regrasIpca:[],
            coberturas: [],
            decessos: [],
            extraFields:[],
            empresa_id: '',
            empresa_nome: '',
            seguradora_id: '',
            seguradora_nome: '',
            filiais: []
          };
          this.regrasMarcadasRemocao = [];
          this.regrasIpcaMarcadasRemocao = [];
          this.coberturasMarcadasRemocao = [];
          this.decessosMarcadasRemocao = [];
          this.empresaBusca = '';
          this.sugestoesEmpresas = [];
          this.seguradoraBusca = '';
          this.sugestoesSeguradoras = [];
        }
      },
      placeHolderValues: {
        handler(newValue) {
          if (newValue && Object.keys(newValue).length > 0) {
            // Keep the reactive reference of `this.data` intact and assign properties
            this.data = Object.assign(this.data, JSON.parse(JSON.stringify(newValue)));
            
            if (!this.data.regras) this.data.regras = [];
            else this.data.regras.forEach(r => r.marcado_remocao = false);

            if (!this.data.regrasIpca) this.data.regrasIpca = [];
            else this.data.regrasIpca.forEach(r => r.marcado_remocao = false);

            if (!this.data.coberturas) this.data.coberturas = [];
            else this.data.coberturas.forEach(r => r.marcado_remocao = false);

            if (!this.data.decessos) this.data.decessos = [];
            else this.data.decessos.forEach(r => r.marcado_remocao = false);

            if (!this.data.extraFields) this.data.extraFields = [];
            
            this.regrasMarcadasRemocao = [];
            this.regrasIpcaMarcadasRemocao = [];
            this.coberturasMarcadasRemocao = [];
            this.decessosMarcadasRemocao = [];
            this.empresaBusca = this.data.empresa_nome || '';
            this.seguradoraBusca = this.data.seguradora_nome || '';
          }
        },
        deep: true,
        immediate: true
      }
    }, 
    data() {
      return {
        data:
        {  
          regras: [],
          regrasIpca:[],
          coberturas: [],
          decessos: [],
          extraFields:[],
          empresa_id: '',
          empresa_nome: '',
          seguradora_id: '',
          seguradora_nome: '',
          filiais: []
        },
        extraObect:{},
        novaRegraIpca:{},
        novaRegra: {},
        novaCobertura: {},
        novoDecesso: {},
        regrasMarcadasRemocao: [],
        regrasIpcaMarcadasRemocao: [],
        coberturasMarcadasRemocao: [],
        decessosMarcadasRemocao: [],
        empresaBusca: '',
        sugestoesEmpresas: [],
        seguradoraBusca: '',
        sugestoesSeguradoras: [],
        onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
      };
    },
    methods: {
      async _buscarEmpresas() {
        if (!this.empresaBusca || this.empresaBusca.length < 4) {
          this.sugestoesEmpresas = [];
          return;
        }
        this.getEmpresas(this.empresaBusca);
      },
      async getEmpresas(query) {
        this.loading = true;
        const empresasRepo = new EmpresasRepository();
        try {
          const response = await empresasRepo.getEmpresaQuery(this.onlineUser.token, query);
          if (response?.status === 200) {
            this.loading = false;
            this.sugestoesEmpresas = response.data;
          } else {
            this.loading = false;
            this.error = response?.message;
          }
        } catch (error) {
          this.loading = false;
          handleUnauthorized(error);
        }
      },
      vincularEmpresaLista(empresa){
        this.data.empresa_id = empresa.id;
        this.data.empresa_nome = empresa.nome;
        // Limpa a busca pra ficar clean
        this.empresaBusca = '';
        this.sugestoesEmpresas = [];
      },
      async _buscarSeguradoras() {
        if (!this.seguradoraBusca || this.seguradoraBusca.length < 3) {
          this.sugestoesSeguradoras = [];
          return;
        }
        this.getSeguradoras(this.seguradoraBusca);
      },
      async getSeguradoras(query) {
        this.loading = true;
        const seguradorasRepo = new SeguradoraRepository();
        try {
          const response = await seguradorasRepo.getSeguradoraQuery(this.onlineUser.token, query);
          if (response?.status === 200) {
            this.loading = false;
            this.sugestoesSeguradoras = response.data;
          } else {
            this.loading = false;
            this.error = response?.message;
          }
        } catch (error) {
          this.loading = false;
          handleUnauthorized(error);
        }
      },
      vincularSeguradoraLista(seguradora){
        this.data.seguradora_id = seguradora.id;
        this.data.seguradora_nome = seguradora.nome;
        this.seguradoraBusca = '';
        this.sugestoesSeguradoras = [];
      },
      sendData(e) {
        e.preventDefault();
        
        let payload = JSON.parse(JSON.stringify(this.data));
        payload.regras = payload.regras.filter(r => !r.marcado_remocao);
        payload.regrasIpca = payload.regrasIpca.filter(r => !r.marcado_remocao);
        payload.coberturas = payload.coberturas.filter(r => !r.marcado_remocao);
        payload.decessos = payload.decessos.filter(r => !r.marcado_remocao);

        // Anexar propriedades de deleção ao objeto base
        payload.deletar_regras = this.regrasMarcadasRemocao;
        payload.deletar_regras_ipca = this.regrasIpcaMarcadasRemocao;
        payload.deletar_coberturas = this.coberturasMarcadasRemocao;
        payload.deletar_decessos = this.decessosMarcadasRemocao;

        if (this.data.id) {
            this.$emit('editing-data', payload, this.data.id);
        } else {
            this.$emit('data', payload);
        }
      },
      closeDialog() {
        this.$emit('update-open', false);  // Emite um evento para o componente pai alterar a prop "open"
      },
      addExtraField() {
        this.data.extraFields.push(this.extraObect); // Adiciona o novo objeto ao array
        this.extraObect = {}
      },
      removeExtraField(index) {
        this.data.extraFields.splice(index, 1); // Remove o campo extra do array
      },

      adicionarRegra() {
        const novo = { ...this.novaRegra };
        if (!novo.nome) {
          return;
        }

        this.data.regras.push(novo);
        this.novaRegra = {
          nome: '',
          tipo:'',
          idade_min: '',
          idade_max: '',
          tipo_reenquadramento: '',
          observacao:'',
        };
      },

      adicionarRegraIpca() {
        const novo = { ...this.novaRegraIpca };
        if (!novo.nome) {
          return;
        }

        this.data.regrasIpca.push(novo);
        this.novaRegraIpca = {
          nome: '',
          tipo:'',
          tipo_reenquadramento: '',
          observacao:'',
          data_fixa: '',
        };
      },

      removerRegra(index) {
        let regra = this.data.regras[index];
        if (regra.id) {
           regra.marcado_remocao = true;
           this.regrasMarcadasRemocao.push(regra.id);
        } else {
           this.data.regras.splice(index, 1);
        }
      },

      desfazerRemocaoRegra(index) {
        let regra = this.data.regras[index];
        regra.marcado_remocao = false;
        this.regrasMarcadasRemocao = this.regrasMarcadasRemocao.filter(id => id !== regra.id);
      },

      removerRegraIpca(index) {
        let regra = this.data.regrasIpca[index];
        if (regra.id) {
           regra.marcado_remocao = true;
           this.regrasIpcaMarcadasRemocao.push(regra.id);
        } else {
           this.data.regrasIpca.splice(index, 1);
        }
      },

      desfazerRemocaoRegraIpca(index) {
        let regra = this.data.regrasIpca[index];
        regra.marcado_remocao = false;
        this.regrasIpcaMarcadasRemocao = this.regrasIpcaMarcadasRemocao.filter(id => id !== regra.id);
      },

      adicionarCobertura() {
        const novo = { ...this.novaCobertura };
        if (!novo.nome || !novo.chave_placeholder) {
          return;
        }

        this.data.coberturas.push(novo);
        this.novaCobertura = {
          nome: '',
          chave_placeholder: '',
          valor: ''
        };
      },

      removerCobertura(index) {
        let cobertura = this.data.coberturas[index];
        if (cobertura.id) {
           cobertura.marcado_remocao = true;
           this.coberturasMarcadasRemocao.push(cobertura.id);
        } else {
           this.data.coberturas.splice(index, 1);
        }
      },

      desfazerRemocaoCobertura(index) {
        let cobertura = this.data.coberturas[index];
        cobertura.marcado_remocao = false;
        this.coberturasMarcadasRemocao = this.coberturasMarcadasRemocao.filter(id => id !== cobertura.id);
      },

      adicionarDecesso() {
        const novo = { ...this.novoDecesso };
        if (!novo.nome || !novo.sigla) {
          return;
        }

        this.data.decessos.push(novo);
        this.novoDecesso = {
          nome: '',
          sigla: '',
          valor_capital: '',
          valor_premio: ''
        };
      },

      removerDecesso(index) {
        let decesso = this.data.decessos[index];
        if (decesso.id) {
           decesso.marcado_remocao = true;
           this.decessosMarcadasRemocao.push(decesso.id);
        } else {
           this.data.decessos.splice(index, 1);
        }
      },

      desfazerRemocaoDecesso(index) {
        let decesso = this.data.decessos[index];
        decesso.marcado_remocao = false;
        this.decessosMarcadasRemocao = this.decessosMarcadasRemocao.filter(id => id !== decesso.id);
      }
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
      DynamicTable
    },
  }
</script>